
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    modelValue: { type: String, default: "" },
    name: { type: String, default: "" },
    block: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
  emits: [
    "update:modelValue",
  ],
});
